import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";

import { AppComponent } from "./app.component";
import { WelcomeComponent } from "./pages/welcome/welcome.component";
import { InstructionsComponent } from "./pages/instructions/instructions.component";
import { GamePageComponent } from "./pages/game-page/game-page.component";
import { ScoreComponent } from "./pages/score/score.component";
import { MemoryGameComponent } from "./components/memory-game/memory-game.component";
import { GameLabelPipe } from "./pipes/game-label.pipe";

@NgModule({
  declarations: [
    AppComponent,
    WelcomeComponent,
    InstructionsComponent,
    GamePageComponent,
    ScoreComponent,
    MemoryGameComponent,
    GameLabelPipe,
  ],
  imports: [BrowserModule, BrowserAnimationsModule],
  providers: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
